<template>
  <div>
    <form>
      <b-field grouped class="column-direction-touch">
        <AppPorcentagem
          ref="inputPercentual"
          v-if="maiorDesconto"
          permitir-percentual-zero
          :calcular-valor="maiorDesconto"
          :carregar-percentual="carregarDados"
          :desabilitar-campos="desabilitarCamposProposta"
          :label="'Percentual'"
          :placeholder="'Percentual'"
          :item="item"
          :percentual-valido="percentualValido"
          :valores="valores"
          :valor-percentual="dados.percentual"
          :width="'110'"
          @valor="atualizarValores"
        />

        <AppValor
          ref="inputValor"
          v-if="!maiorDesconto"
          :carregar-valor="carregarDados"
          :desabilitar-campos="desabilitarCamposProposta"
          :label="'Valor unitário'"
          :exibir-input="true"
          :item="item"
          :placeholder="'Valor unitário'"
          :valor-valido="valorValido"
          :valores="valores"
          :valor-monetario="dados.valorUnitario"
          :width="'160'"
          @valor="atualizarValores"
        />

        <b-field v-if="maiorDesconto && existeReferencial" label="Valor unitário">
          <b-input disabled :value="valorUnitarioFormatado" />
        </b-field>

        <b-field label="Quantidade">
          <b-input disabled :value="quantidadeFormatada" />
        </b-field>

        <b-field v-if="!maiorDesconto || existeReferencial" label="Valor total">
          <b-input disabled :value="valorTotalFormatado" />
        </b-field>

        <b-field
          expanded
          label="Marca/Modelo"
          :type="campoInvalido('marca') ? 'is-danger' : ''"
          :message="campoInvalido('marca') ? 'Insira uma marca' : ''"
        >
          <b-input
            expanded
            custom-class="uppercase"
            placeholder="Marca/Modelo"
            :disabled="desabilitarCamposProposta"
            v-model="$v.dados.marca.$model"
            @blur="evento => converterMaiusculo('marca', evento.target.value)"
          ></b-input>
        </b-field>

        <b-field
          :expanded="tablet"
          label="Fabricado"
          :type="campoInvalido('fabricado') ? 'is-danger' : ''"
          :message="campoInvalido('fabricado') ? 'Selecione uma opção' : ''"
        >
          <b-field :expanded="tablet">
            <b-radio-button
              :expanded="tablet"
              v-model="dados.fabricado"
              native-value="BRASIL"
              :disabled="desabilitarCamposProposta"
              >Brasil</b-radio-button
            >
            <b-radio-button
              :expanded="tablet"
              v-model="dados.fabricado"
              native-value="IMPORTADO"
              :disabled="desabilitarCamposProposta"
              >Importado</b-radio-button
            >
          </b-field>
        </b-field>

        <b-tooltip position="is-left" :active="showBillingWarning" type="is-danger">
          <template #content>
            <span>{{ billingTooltipMessage }}</span>
          </template>

          <b-field style="height: 100%">
            <button
              class="button is-primary is-fullwidth send-proposal-button"
              style="height: 100%"
              @click.stop.prevent="informarPIN(item.id)"
              :disabled="desabilitarCamposProposta || enviandoProposta"
            >
              {{ enviandoProposta ? 'Aguarde...' : textoBotao }}
            </button>
          </b-field>
        </b-tooltip>
      </b-field>
    </form>

    <b-modal :active.sync="validandoPIN" :onCancel="resetarEstado" has-modal-card>
      <pin-form v-if="validandoPIN" :reason="reasonPIN" @validar="enviarProposta" />
    </b-modal>

    <b-modal has-modal-card :active.sync="declarationsModal" :onCancel="cancelDeclarations">
      <DeclarationsModal
        v-if="declarationsModal"
        :showPreference="showPreferenceDeclarations"
        :companySize="company.companySize"
        @confirm="handleDeclarationsConfirm"
        @cancel="cancelDeclarations"
      />
    </b-modal>
  </div>
</template>

<script>
import Big from 'big.js';
import { mapActions, mapGetters, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import AppValor from '@/components/AppValor';
import AppPorcentagem from '@/components/AppPorcentagem';
import BILLING_MESSAGES from '@/constants/billingMessages';
import campo from '@/mixins/formulario';
import { formatarNumero, formatarValor } from '@/utils/format';
import { resolveUnitInput, totalFromUnit, unitFromDiscount } from '@/utils/proposalAmounts';
import PinForm from '@/views/User/Pin';
import DeclarationsModal from './DeclarationsModal';

export default {
  name: 'SendProposal',
  props: {
    item: Object,
  },
  components: {
    PinForm,
    AppValor,
    AppPorcentagem,
    DeclarationsModal,
  },
  mixins: [campo],
  data() {
    const dados = {
      ofertaCompraItemId: 0,
      propostaId: 0,
      valorUnitario: 0,
      valorTotal: 0,
      percentual: 0,
      marca: '',
      fabricado: '',
    };

    return {
      dados,
      reasonPIN: '',
      validandoPIN: false,
      desabilitarPorProposta: false,
      modo: '',
      carregarDados: false,
      enviandoProposta: false,
      valores: {},
      declarationsModal: false,
      declarationsModalShown: false,
      pendingSendProposal: false,
    };
  },
  validations: {
    dados: {
      marca: { required },
      fabricado: { required },
    },
  },
  computed: {
    ...mapGetters('app', { tablet: 'tablet' }),
    ...mapState('companies', ['company']),
    ...mapState('companyBilling', ['status', 'currentBillingMethodId', 'companyCredits']),
    ...mapGetters('companyBilling', ['hasBillingWarning']),
    ...mapGetters({
      ofertaCompra: 'obterOfertaCompra',
      pinValido: 'getValidPin',
      isSineDieFromEntregaDePropostas: 'isSineDieFromEntregaDePropostas',
    }),
    ...mapGetters({
      logged: 'getLogged',
    }),
    ...mapGetters('proposals', { proposals: 'obterPropostasUsuarioLogado' }),
    ...mapGetters('auctionsDeclarations', {
      auctionDeclarations: 'getDeclarations',
    }),
    existeReferencial() {
      return Number(this.item.referencia) > 0;
    },
    maiorDesconto() {
      return this.tipoNegociacao === 3;
    },
    valorValido() {
      if (Number.isNaN(this.dados.valorUnitario)) return false;
      const valor = new Big(this.dados.valorUnitario || 0);
      return valor.gt(0) && valor.lt(999999999.9999);
    },
    percentualValido() {
      const percentual = new Big(this.dados.percentual || 0);

      return percentual.gte(0) && percentual.lt(100);
    },
    tipoNegociacao() {
      return this.ofertaCompra.tipo_negociacao.id;
    },
    textoBotao() {
      if (this.modo === 'editar') return 'Atualizar Proposta';
      return 'Enviar Proposta';
    },
    showPreferenceDeclarations() {
      return (
        this.company.preference &&
        this.ofertaCompra.tipo_edital === 'RESERVADO' &&
        this.ofertaCompra.preferencia_regional
      );
    },
    showBillingWarning() {
      return this.hasBillingWarning && this.proposals.length === 0;
    },
    billingTooltipMessage() {
      return BILLING_MESSAGES.TOOLTIP_WARNING;
    },
    desabilitarCamposProposta() {
      return (
        this.isSineDieFromEntregaDePropostas ||
        (this.hasBillingWarning && this.proposals.length === 0) ||
        this.desabilitarPorProposta
      );
    },
    quantidadeFormatada() {
      return formatarNumero(this.item.quantidade || 0);
    },
    valorUnitarioFormatado() {
      return formatarValor(this.dados.valorUnitario || 0);
    },
    valorTotalFormatado() {
      return formatarValor(this.dados.valorTotal || 0);
    },
  },
  methods: {
    ...mapActions('proposals', ['createProposal', 'updateProposal']),
    ...mapActions('companyBilling', ['getCompanyCredits', 'getCompanyCurrentBillingMethod']),
    ...mapActions('auctionsDeclarations', ['createAuctionDeclaration', 'removeAuctionDeclaration']),
    ...mapActions(['invalidatePin']),
    atualizarTotais() {
      if (this.maiorDesconto) {
        if (this.existeReferencial) {
          this.dados.valorUnitario = unitFromDiscount(this.item.referencia, this.dados.percentual);
          this.dados.valorTotal = totalFromUnit(this.dados.valorUnitario, this.item.quantidade);
        } else {
          this.dados.valorUnitario = 0;
          this.dados.valorTotal = 0;
        }
        return;
      }

      this.dados.valorTotal = totalFromUnit(this.dados.valorUnitario, this.item.quantidade);
    },
    atualizarValores(dados) {
      if (this.maiorDesconto) {
        this.dados.percentual = dados.percentual;
      } else {
        this.dados.valorUnitario = dados.valor;
      }
      this.valores = dados;
      this.atualizarTotais();
    },
    montarPayload() {
      const payload = {
        ofertaCompraItemId: this.dados.ofertaCompraItemId,
        marca: this.dados.marca,
        fabricado: this.dados.fabricado,
        empresaId: this.company.id,
      };

      if (this.dados.propostaId) {
        payload.propostaId = this.dados.propostaId;
      }

      if (this.maiorDesconto) {
        payload.percentual = this.dados.percentual;
      } else {
        payload.valorUnitario = this.dados.valorUnitario;
      }

      return payload;
    },
    async habilitarDesabilitarCampos(itemId) {
      const propostaFiltro =
        (await this.proposals.findIndex(proposta => proposta.oferta_compra_item_id === itemId)) >=
        0;

      if (propostaFiltro && this.$vnode.key === itemId && this.modo === '') {
        this.desabilitarPorProposta = false;
        this.modo = 'editar';
      } else if (propostaFiltro && this.$vnode.key === itemId && this.modo === 'editar') {
        this.desabilitarPorProposta = true;
        this.modo = '';
      }
    },
    propostaTemConteudo(proposta) {
      if (!proposta) return false;
      return (
        (proposta.marca != null && proposta.marca !== '') ||
        (proposta.valorUnitario != null && proposta.valorUnitario !== '') ||
        (proposta.valor != null && proposta.valor !== '') ||
        (proposta.percentual != null && proposta.percentual !== '')
      );
    },
    propostaDoItem() {
      const doItem = this.proposals.filter(
        proposta => proposta.oferta_compra_item_id === this.item.id,
      );
      return doItem.find(proposta => this.propostaTemConteudo(proposta)) || null;
    },
    async envioPropostaItemValido() {
      const propostaFiltro = this.proposals.some(
        proposta => proposta.oferta_compra_item_id === this.item.id,
      );

      this.desabilitarPorProposta = propostaFiltro || this.item.estado === 'REVOGADO';
      if (!propostaFiltro) {
        this.modo = '';
        this.dados.propostaId = 0;
      }
      return false;
    },
    definirProposta() {
      const proposta = this.propostaDoItem();
      if (proposta) {
        this.dados.percentual = Number(proposta.percentual) || 0;
        this.dados.valorUnitario = resolveUnitInput(proposta, this.tipoNegociacao) || 0;
        this.dados.ofertaCompraItemId = proposta.oferta_compra_item_id;
        this.dados.propostaId = proposta.id;
        this.dados.marca = proposta.marca || '';
        this.dados.fabricado = proposta.fabricado || '';
        if (proposta.valorTotal != null && proposta.valorTotal !== '') {
          this.dados.valorTotal = Number(proposta.valorTotal);
        } else {
          this.atualizarTotais();
        }
        this.carregarDados = true;
      } else if (this.maiorDesconto && this.$refs.inputPercentual) {
        this.$refs.inputPercentual.focus();
      } else if (this.$refs.inputValor) {
        this.$refs.inputValor.focus();
      }
    },
    async informarPIN(ofertaCompraItemId) {
      this.dados.ofertaCompraItemId = ofertaCompraItemId;

      if (
        [1, 2].indexOf(this.tipoNegociacao) > -1 &&
        (this.$v.$invalid || this.$refs.inputValor.$v.$invalid)
      ) {
        this.$v.$touch();
        this.$refs.inputValor.$v.$touch();
      } else if (
        this.maiorDesconto &&
        (this.$v.$invalid || this.$refs.inputPercentual.$v.$invalid)
      ) {
        this.$v.$touch();
        this.$refs.inputPercentual.$v.$touch();
      } else if (!this.pinValido) {
        this.validandoPIN = true;
        this.reasonPIN =
          this.modo === 'editar' ? 'PREGAO-ATUALIZAR-PROPOSTA' : 'PREGAO-CRIAR-PROPOSTA';
      } else {
        await this.enviarProposta(true);
      }
    },
    async enviarProposta(pinValido) {
      if (pinValido) {
        if (this.modo === '') {
          // Se é a primeira vez enviando proposta e ainda não mostrou o modal de declarações
          if (this.proposals.length === 0 && !this.declarationsModalShown) {
            this.validandoPIN = false;
            this.pendingSendProposal = true;
            this.declarationsModal = true;
            return;
          }

          if (
            this.status === 'ATIVO' ||
            this.companyCredits > 0 ||
            (this.companyCredits === 0 && this.proposals.length > 0)
          ) {
            await this.executeSendProposal();
          }
        }

        if (this.modo === 'editar' && this.proposals.length > 0) {
          this.enviandoProposta = true;

          const propostaItem =
            this.propostaDoItem() ||
            this.proposals.find(
              proposta =>
                proposta.oferta_compra_item_id === this.dados.ofertaCompraItemId && proposta.id,
            );

          try {
            const payload = this.montarPayload();
            const propostaId = (propostaItem && propostaItem.id) || this.dados.propostaId;
            await this.updateProposal({
              propostaId,
              itemId: this.dados.ofertaCompraItemId,
              proposta: payload,
            });
            this.$alerta('Proposta atualizada', 'is-success');
          } catch (error) {
            const resposta = error.response.data;
            if (resposta.error.type === 'ForaDoPrazo') {
              this.$alerta('Fora do prazo', 'is-danger');
            } else {
              this.$alerta('Erro ao atualizar proposta', 'is-danger');
            }
            if (propostaItem) {
              this.dados.valorUnitario = resolveUnitInput(propostaItem, this.tipoNegociacao) || 0;
              this.dados.percentual = Number(propostaItem.percentual) || 0;
              this.dados.marca = propostaItem.marca;
              this.dados.fabricado = propostaItem.fabricado;
              this.atualizarTotais();
            }
          } finally {
            this.enviandoProposta = false;
            this.desabilitarPorProposta = true;
          }

          if (this.maiorDesconto) {
            this.$refs.inputPercentual.formatarValor();
          } else {
            this.$refs.inputValor.formatarValor();
          }
          await this.getCompanyCredits(this.company.id);
          this.resetarEstado();
        }
      }
    },
    limparDados() {
      this.dados.valorUnitario = 0;
      this.dados.valorTotal = 0;
      this.dados.percentual = 0;
      this.dados.marca = '';
      this.dados.fabricado = '';
    },
    async executeSendProposal() {
      this.enviandoProposta = true;

      try {
        await this.createProposal(this.montarPayload());
        this.$alerta('Proposta enviada', 'is-success');
        this.$v.$reset();
        if (this.maiorDesconto && this.$refs.inputPercentual) {
          this.$refs.inputPercentual.resetarEstado();
        } else if (this.$refs.inputValor) {
          this.$refs.inputValor.resetarEstado();
        }
      } catch (error) {
        const resposta = error && error.response && error.response.data;
        if (resposta && resposta.error && resposta.error.type === 'ForaDoPrazo') {
          this.$alerta('Fora do prazo', 'is-danger');
        } else {
          this.$alerta('Erro ao enviar proposta', 'is-danger');
        }
        this.limparDados();
      } finally {
        this.enviandoProposta = false;
        this.desabilitarPorProposta = true;
      }

      if (this.maiorDesconto && this.$refs.inputPercentual) {
        this.$refs.inputPercentual.formatarValor();
      } else if (this.$refs.inputValor) {
        this.$refs.inputValor.formatarValor();
      }
      await this.getCompanyCredits(this.company.id);
      this.resetarEstado();
    },
    async createDeclaration(declarationType, declarationValue) {
      try {
        if (declarationValue) {
          await this.createAuctionDeclaration({
            auctionId: this.ofertaCompra.id,
            companyId: this.company.id,
            type: declarationType,
            value: declarationValue,
          });
        } else {
          const declaration = this.auctionDeclarations.find(
            element => element.declaration === declarationType,
          );

          if (declaration) {
            await this.removeAuctionDeclaration({
              auctionId: this.ofertaCompra.id,
              companyId: this.company.id,
              declarationId: declaration.id,
            });
          }
        }
      } catch (error) {
        if (error && error.response) {
          const { data } = error.response;
          if (data.error === 'ValidationError' && data.details.message === 'Fora do prazo') {
            this.$alerta(data.details.message, 'is-danger');
            return;
          }
        }

        this.$alerta(
          declarationValue ? 'Erro ao aceitar declaração' : 'Erro ao remover declaração',
          'is-danger',
        );
      }
    },
    async handleDeclarationsConfirm(payload = {}) {
      await this.createDeclaration('requirements', true);

      if (payload.regionalPreference === true) {
        await this.createDeclaration('regionalPreference', true);
      }

      this.declarationsModal = false;
      this.declarationsModalShown = true;
      if (this.pendingSendProposal) {
        this.pendingSendProposal = false;
        this.executeSendProposal();
      }
    },
    cancelDeclarations() {
      this.declarationsModal = false;
      this.pendingSendProposal = false;
      this.validandoPIN = false;
    },
    resetarEstado() {
      if (this.modo === 'editar') this.desabilitarPorProposta = true;
      this.modo = '';
    },
  },
  watch: {
    proposals: {
      handler() {
        if (this.enviandoProposta) return;
        const proposta = this.propostaDoItem();
        if (!proposta) {
          this.envioPropostaItemValido();
          return;
        }
        this.definirProposta();
        this.envioPropostaItemValido();
      },
    },
  },
  async mounted() {
    this.definirProposta();
    this.envioPropostaItemValido();
    this.$onBus('editar', this.habilitarDesabilitarCampos);
    this.$onBus('cancelar-editar', this.habilitarDesabilitarCampos);

    try {
      await this.getCompanyCredits(this.company.id);
      await this.getCompanyCurrentBillingMethod(this.company.id);
    } catch (_error) {
      // Cobrança não pode impedir a visualização da proposta já enviada.
    }
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .send-proposal-button {
    margin-top: 0.5rem;
  }
}

#teste {
  .tooltip-content {
    display: flex !important;
    flex-wrap: wrap !important;
  }
}
</style>
